import React, { useState } from "react"
import { parseBlockContent } from "helpers/parseBlockContent"
import { Grid, Row, Col } from "UI/Grid"
import { ReactComponent as DownloadIcon } from "icons/download-icon.svg"
import { Content } from "UI/Content"
import { Categories } from "../../Project/Categories"
import { Breadcrumbs } from "../../UI/Breadcrumbs"
import { SearchResults } from "../../Project/SearchResults"
import { CaseStudy } from "../../Project/CaseStudy"
import AvenueLink from "UI/AvenueLink"
import { Document, Page } from "react-pdf"
import PDFViewer from "pdf-viewer-reactjs"
import { useStaticQuery, graphql } from "gatsby"
import { LocationModule } from "../../Project/LocationModule"

import {
  InternalTemplateContainer,
  InternalRHSMenu,
  PageTitle,
  PageDetails,
  Footnotes,
  LeftCol,
  PDFWrap,
} from "./style"

const InternalTemplate = ({
  pageData,
  relatedResources,
  variation,
  caseStudy,
}) => {
  const {
    title,
    content,
    uri,
    publicLibrary,
    categories,
    relatedCaseStudy,
  } = pageData
  const parsedContent = content ? parseBlockContent(content) : null


  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  const staticQuery = useStaticQuery(
    graphql`
      query {
        latestPosts: allWpPost(limit: 6) {
          nodes {
            title
            link
            uri
          }
        }

        latestCS: allWpCaseStudy(limit: 6) {
          nodes {
            title
            link
            uri
          }
        }
      }
    `
  )
  

  return (
    <InternalTemplateContainer variation={variation}>
      <Grid>
        <Row>
          <LeftCol xs={12} md={9}>
            
            <Breadcrumbs title={title} uri={uri} />
            <Content>{parsedContent}</Content>
            
          </LeftCol>
          <Col xs={12} md={3}>
          <LocationModule />
          </Col>
        </Row>
      </Grid>
    </InternalTemplateContainer>
  )
}

export default InternalTemplate
